module.exports = __webpack_public_path__ + "static/media/Im1.60050d1b.svg";